import {TrackType} from '../../../../../../../../../types';

export const defaultTrackType = TrackType.Semester;
export const defaultNewMarkingPeriodName = 'New Marking Period';
